import React, { useEffect, useRef, useState } from "react";
import "./Editor.css";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Bold from "@tiptap/extension-bold";
import Italic from "@tiptap/extension-italic";
import { Container, Flex } from "../../layout";
import { Text } from "../../ui";
import { TbBold, TbItalic } from "react-icons/tb";

const SimpleEditor = ({ label, onChange, value, placeholder = "" }) => {
  const [isActive, setIsActive] = useState(false);
  const inputRef = useRef(null);

  const editor = useEditor({
    extensions: [StarterKit, Bold, Italic],
    content: value || "",
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
  });

  useEffect(() => {
    if (editor && value !== editor.getHTML() && value !== undefined) {
      editor.commands.setContent(value, false);
    }
  }, [value, editor]);

  const handleFocus = () => {
    setIsActive(true);
    inputRef.current?.focus();
  };

  const handleBlur = () => {
    setIsActive(false);
  };

  return (
    <Container className="Editor SimpleEditor">
      {label && (
        <Text size="sm" className="text-sm" onClick={handleFocus}>
          {label}
        </Text>
      )}

      <Container className={`ctn-editor ${isActive ? "active" : ""}`}>
        {editor && (
          <Flex className="toolbar simple-toolbar" gap={10}>
            <Flex
              onClick={() => editor.chain().focus().toggleBold().run()}
              className={editor.isActive("bold") ? "active" : ""}
              title="Gras"
            >
              <TbBold />
            </Flex>
            <Flex
              onClick={() => editor.chain().focus().toggleItalic().run()}
              className={editor.isActive("italic") ? "active" : ""}
              title="Italique"
            >
              <TbItalic />
            </Flex>
          </Flex>
        )}

        <EditorContent
          editor={editor}
          ref={inputRef}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </Container>
    </Container>
  );
};

export default SimpleEditor;
